import { GetRegionByText } from '../defines/client.const';
import {GetSubRegionByText, POOMSA, REGION} from '../defines/gukeo.const';
import {GetPoomSa} from '../defines/gukeo.func';
import {SimpleWord} from './simple-word.model';
import {IsEmptyString} from "../defines/common.func";


export class SimpleDialect {
  id: string;
  area1: string;
  area2: string;

  word: string;
  word2: string;
  wordMore: string;

  meaning2: Array<string>;
  region: REGION;
  region2: REGION;

  offsetTop?: number; // 단어가 화면에 표시되는 위치 (단어가 화면에 표시되는 위치를 저장한다. 속도 향상을 위해서 저장.)

  constructor(obj?: any) {
    this.id               = (obj && obj.id)                 ?? null;
    this.area1            = (obj && obj.area1)              ?? null;
    this.area2            = (obj && obj.area2)              ?? null;

    this.word             = (obj && obj.word)               ?? null;
    this.word2            = (obj && obj.word2)              ?? null;
    this.wordMore         = (obj && obj.word_more)          ?? null;

    this.meaning2         = (obj && obj.meaning2)           ? String(obj.meaning2).split('|') : null;

    if (this.area1) {
      const regionInfo    = GetRegionByText(this.area1);
      this.region         = regionInfo ? regionInfo.region : null;
    }
    if (this.area2) {
      const subInfo       = GetSubRegionByText(this.area2);
      this.region2        = subInfo ? subInfo.region : null;
    }
  }

  public GetMeaning2Nth(nth: number): string | null {
    const meaning = this.meaning2?.[nth] ?? null;
    return IsEmptyString(meaning) ? null : meaning;
  }
}

export interface DialectMapPayload {
  word: SimpleWord | null;
  dialects: Array<SimpleDialect>;
}

export class Dialect extends SimpleDialect {
  standardWord: string;
  standard: SimpleWord;

  partOfSpeech: Array<POOMSA>;
  meaning3: Array<string>;
  example2: Array<string>;
  example3: Array<string>;
  explanation2: Array<string>;
  explanation3: Array<string>;

  bookmark: boolean;

  dialects: Array<SimpleDialect>;


  constructor(obj?: any) {
    super(obj);

    this.standardWord     = (obj && obj.standard_word)      ?? null;
    this.standard         = (obj && obj.standard)           ? new SimpleWord(obj.standard) : null;

    this.partOfSpeech     = (obj && obj.part_of_speech)     ? GetPoomSa(obj.part_of_speech) : null;
    this.meaning3         = (obj && obj.meaning3)           ? String(obj.meaning3).split('|') : null;
    this.example2         = (obj && obj.example2)           ? String(obj.example2).split('|') : null;
    this.example3         = (obj && obj.example3)           ? String(obj.example3).split('|') : null;
    this.explanation2     = (obj && obj.explanation2)       ? String(obj.explanation2).split('|') : null;
    this.explanation3     = (obj && obj.explanation3)       ? String(obj.explanation3).split('|') : null;

    this.bookmark         = (obj && obj.bookmark)           ?? null;

    if (obj && 'dialects' in obj) {
      this.dialects = new Array<SimpleDialect>();
      obj.dialects.forEach(value => this.dialects.push(new SimpleDialect(value)));
    }
  }

  // this.aialects 에 자신을 포함시킨다.
  // 주의: 이 함수는 Angular의 ChangeDetect을 발생할 수 있어서, 원치 않게 화면 갱신이 발생할 수 있다.
  //      그런 경우에는 값을 담아 놓고 쓰자.
  public get allDialects(): Array<SimpleDialect> {
    return [this, ...this.dialects];
    //   new SimpleDialect({
    //     area1:    '강원도',
    //     word:     '강원말',
    //     word2:    '강원말',
    //     meaning2: '강원말뜻',
    //   }),
    //   new SimpleDialect({
    //     area1:    '제주도',
    //     word:     '제주말',
    //     word2:    '제주말',
    //     meaning2: '제주말뜻',
    //   }),
    // ];
  }

  public GetMeaning3Nth(nth: number): string | null {
    const meaning = this.meaning3?.[nth] ?? null;
    return IsEmptyString(meaning) ? null : meaning;
  }

  /**
   * 예문 배열 가지고 오는 함수.
   * (규칙이 복잡함)
   * 뜻이 하나 있는 경우: 첫번째 예문 사용
   * 뜻이 두개 이상 있는 경우 (= 기본 뜻이 있는 경우): 기본 뜻에는 예문이 없다. 그래서 (예문 갯수 === 뜻 갯수 - 1)
   * @param nth
   * @constructor
   * @protected
   */
  public GetExample3Nth(nth: number): string | null {
    if ((this.meaning3?.length ?? 0) > 1) {
      // 뜻이 두개 이상인 경우
      // 뜻 0번은 기본 뜻이라서 예문이 없다.
      // 뜻 1번부터 예문이 있어서 -1을 해줌.
      return nth === 0 ? null : this.example3?.[nth - 1] ?? null;
    }
    else {
      return this.example3?.[nth] ?? null;
    }
  }

  public GetExplanation3Nth(nth: number): string | null {
    let explanation: string | null = null;
    if ((this.meaning3?.length ?? 0) > 1) {
      explanation = nth === 0 ? null : this.explanation3?.[nth - 1] ?? null;
    }
    else {
      explanation = this.explanation3?.[nth] ?? null;
    }
    return IsEmptyString(explanation) ? null : explanation;
  }
}
